import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';
import './index.css'
import { initializeConfig } from './config';
import { setupI18n } from './i18n';
import { setAppSplashMessage } from './layout/ui/appSplash';
// import { SnackbarProvider } from 'notistack';

// Codex Deleted: 設定取得後に翻訳初期化を始める直列待ちを削除し、起動時の待機時間を減らす。
// Codex Added: 独立した設定取得と翻訳初期化を並行実行し、両方の完了後にUIを起動する。
Promise.all([initializeConfig(), setupI18n()]).then(() => {

  const Root = React.lazy(() => import('./layout/ui/root'));
  setAppSplashMessage("Loading UI...");

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    // <React.StrictMode>
    <StyledEngineProvider injectFirst>
      {/* <SnackbarProvider> */}

      <Suspense fallback={<></>}>
        <Root />
      </Suspense>
      {/* </SnackbarProvider> */}

    </StyledEngineProvider>
    // </React.StrictMode>,
  )

  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = new URL('./serviceworker.ts', import.meta.url);
      navigator.serviceWorker.register(swUrl, { type: 'module', scope: '/' }).catch((error) => {
        console.error('[serviceworker] registration failed', error);
      });
    });
  }

})
